import { useSelector } from "react-redux";

import EbookPage from "../readers_book/EbookPage";
import BookSyntaxPage from "../readers_book/syntax/BookSyntaxPage";
import BookWorkbookPage from "./book/BookWorkbookPage";
import ChapterBookPage from "./chapter_book/ChapterBookPage";
import DeprecatedComprehensivePage from "./deprecated/DeprecatedComprehensivePage";
import OXPage from "./OX/OXPage";
import ScramblePage from "./scramble/ScramblePage";
import SummaryBlankPage from "./summary/SummaryBlankPage";
import TranslationPage from "./translation/TranslationPage";
import UnderstandingTestPage from "./understanding/UnderstandingTestPage";
import VocabularyPage from "./vocabulary/VocabularyPage";

const ComprehensivePage = ({ setCurrentStep, isPreview, isReview }) => {
  const { section } = useSelector((state) => state.assignment);

  // 챕터북(원서 모드의 한 갈래). 챕터 하나가 섹션 하나다.
  if (section.type === "chapter_book") {
    return (
      <ChapterBookPage
        setCurrentStep={setCurrentStep}
        isPreview={isPreview}
        isReview={isReview}
      />
    );
  }

  // 원서 워크북의 '책 보기'(2026-10-24). 문제집 쪽을 리더스북 전자책 화면으로 넘겨 읽기만 한다.
  if (section.type === "ebook") {
    return (
      <EbookPage
        setCurrentStep={setCurrentStep}
        isPreview={isPreview}
        isReview={isReview}
      />
    );
  }

  // 지문분석 조교 워크북의 지문 구문분석(2026-10-24). 리더스북 구문분석 책 화면을 그대로 쓴다.
  if (section.type === "syntax_analysis") {
    return (
      <BookSyntaxPage
        setCurrentStep={setCurrentStep}
        isPreview={isPreview}
        isReview={isReview}
      />
    );
  }

  // 원서 워크북(지인에듀 mode=book). 세트 하나가 섹션 하나다.
  if (section.type === "book") {
    return (
      <BookWorkbookPage
        setCurrentStep={setCurrentStep}
        isPreview={isPreview}
        isReview={isReview}
      />
    );
  }

  if (section.type === "comprehensive") {
    return (
      <DeprecatedComprehensivePage
        setCurrentStep={setCurrentStep}
        isPreview={isPreview}
        isReview={isReview}
      />
    );
  } else if (
    [
      "ox_kor",
      "ox_kor_high",
      "ox_eng",
      "ox_eng_high",
      "ox"
    ].includes(section.type)
  ) {
    return (
      <OXPage
        setCurrentStep={setCurrentStep}
        isPreview={isPreview}
        isReview={isReview}
      />
    );
  } else if (
    [
      "paraphrasing_scramble",
      "scramble"
    ].includes(section.type)
  ) {
    return (
      <ScramblePage
        setCurrentStep={setCurrentStep}
        isPreview={isPreview}
        isReview={isReview}
      />
    );
  } else if (
    [
      "summary_blank_low",
      "summary_blank",
      "summary"
    ].includes(section.type)
  ) {
    return (
      <SummaryBlankPage
        setCurrentStep={setCurrentStep}
        isPreview={isPreview}
        isReview={isReview}
      />
    );
  } else if (section.type === "translation") {
    return (
      <TranslationPage
        setCurrentStep={setCurrentStep}
        isPreview={isPreview}
        isReview={isReview}
      />
    );
  } else if (
    [
      "understanding_test",
      "understanding"
    ].includes(section.type)
  ) {
    return (
      <UnderstandingTestPage
        setCurrentStep={setCurrentStep}
        isPreview={isPreview}
        isReview={isReview}
      />
    );
  } else if (
    [
      "keyword_meaning",
      "keyword"
    ].includes(section.type)
  ) {
    return (
      <VocabularyPage
        setCurrentStep={setCurrentStep}
        isPreview={isPreview}
        isReview={isReview}
      />
    );
  } else if (section.type === "num_repeats") {
    return (
      <VocabularyPage
        setCurrentStep={setCurrentStep}
        isPreview={isPreview}
        isReview={isReview}
      />
    );
  }
  return <div></div>;
};

export default ComprehensivePage;
